module.exports = __webpack_public_path__ + "media/images/ico_presta-113ebc99df51a6b37cb235581c23397c.svg";